import { getField, updateField } from 'vuex-map-fields'
import { getNewId } from '@/utils/id'
import BaseStore from '@/store/baseStore'

export const namespaced = true

const baseUrl = '/su_tables/'

const baseStore = new BaseStore(baseUrl)

const getDefaultState = () => ({
  ...structuredClone(baseStore.state),
  fields: ['name'],
  baseItem: {
    name: '',
    project: null
  }
})
export const state = getDefaultState()

export const mutations = {
  ...baseStore.mutations,
  ADD_END_ITEM(state, item) {
    state.items.push(item)
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  },
  updateField
}
export const actions = {
  ...baseStore.actions,
  resetState({ commit }) {
    commit('RESET_STATE')
  },
  async add(context, item) {
    item.id = getNewId(state.items, 'id')
    context.commit('ADD_END_ITEM', item)
    context.commit('ADD_COUNT', 1)
  }
}

export const getters = {
  getField,
  getEmptyItem: (state) => {
    let emptyObj = {}
    if (state.options) {
      Object.keys(state.options).forEach((key) => {
        if (state.options[key].type === 'choice') {
          emptyObj[key] = state.options[key]['choices'][0].value
        } else if (state.options[key].type === 'boolean') {
          emptyObj[key] = false
        } else if (state.options[key].type === 'string') {
          emptyObj[key] = ''
        } else {
          emptyObj[key] = null
        }
      })
    }
    return emptyObj
  }
}
